export const colors = {
  black: "#000000",
  white: "#FFFFFF",
  transparent: "transparent",
  primary: "#041320",
  primaryVariant: "#082237",
  gray1: "#ADBFCD",
  gray2: "#7C8892",
  gray3: "#4A5A67",
  turquoise: "#1BC3D9",
  turquoise2: "#63EAC9",
  emerald: "#1A899E",
  emerald2: "#18616F",
  emerald2Alpha: "#CC18616F",
  emerald3: "#106D7E",
  rose: "#EB7E80",
  darkRose: "#b61c1f",
  blue1: "#0D3F54",
  blue2: "#03111D",
  blue3: "#0B1B2A",
  blue4: "#152A3D",
  blue5: "#0A1C2B",
  darkBlue: "#0A1C2B",
  darkBlue2: "#03111D",
  darkBlue4: "#152A3D",
  green: "#4ECCB1",
}; 
